import * as Ariakit from '@ariakit/react';
import { getClassNames } from '@websolutespa/bom-core';
import { forwardRef, ReactElement, ReactNode, useContext } from 'react';
import styled from 'styled-components';
import { getVariantKey } from '../../variants';
import { Role } from '../role/role';
import { UIStyledComponentProps } from '../types';
import { getCssResponsive } from '../utils';
import { AccordionIcon } from './accordion-icon';
import { AccordionContext } from './accordion.context';
import { accordionVariants, IAccordionVariants } from './accordion.variants';

const AccordionTitleStyle = styled(Ariakit.Disclosure) <AccordionTitleProps>`
  ${props => getVariantKey('title', props.variant, props.variants)}
  ${props => getCssResponsive(props)}
`;

export type AccordionTitleProps = Ariakit.DisclosureProps & UIStyledComponentProps<{
  className?: string;
  variant?: keyof typeof accordionVariants | (string & {});
  variants?: IAccordionVariants;
  children?: ReactNode;
  icon?: ReactElement;
  asChild?: boolean;
}>;

export const AccordionTitle = forwardRef<HTMLButtonElement, AccordionTitleProps>(
  function AccordionTitle({
    asChild,
    className,
    variant,
    variants,
    children,
    icon,
    ...props
  }, ref) {
    const context = useContext(AccordionContext);
    const disclosure = Ariakit.useDisclosureContext();
    const active = disclosure?.getState().open || false;
    const classNames = getClassNames('accordion__title', className, { active });
    return (
      <AccordionTitleStyle
        className={classNames}
        variant={variant || context.variant}
        variants={variants || context.variants}
        ref={ref}
        {...props}
        render={asChild ? (
          <Role />
        ) : (
          undefined
        )}
      >{children} {icon || <AccordionIcon active={active} />}
      </AccordionTitleStyle>
    );
  }
);
